var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserGroup03SolidRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.60499 3.60985C8.05278 4.45845 7 6.10628 7 8C7 9.0141 7.3019 9.95769 7.82074 10.7458C5.83291 10.6522 4.25 9.01097 4.25 7C4.25 4.92893 5.92893 3.25 8 3.25C8.5743 3.25 9.11844 3.3791 9.60499 3.60985ZM8.52478 12.25C5.91038 13.0115 4 15.4255 4 18.2857C4 18.8057 4.10685 19.3007 4.29978 19.75H3.71429C2.3533 19.75 1.25 18.6467 1.25 17.2857C1.25 14.5046 3.50457 12.25 6.28571 12.25H8.52478ZM12 4.25C9.92893 4.25 8.25 5.92893 8.25 8C8.25 10.0711 9.92893 11.75 12 11.75C14.0711 11.75 15.75 10.0711 15.75 8C15.75 5.92893 14.0711 4.25 12 4.25ZM10.2857 13.25C7.50457 13.25 5.25 15.5046 5.25 18.2857C5.25 19.6467 6.3533 20.75 7.71429 20.75H16.2857C17.6467 20.75 18.75 19.6467 18.75 18.2857C18.75 15.5046 16.4954 13.25 13.7143 13.25H10.2857ZM17 8C17 9.0141 16.6981 9.95769 16.1793 10.7458C18.1671 10.6522 19.75 9.01097 19.75 7C19.75 4.92893 18.0711 3.25 16 3.25C15.4257 3.25 14.8816 3.3791 14.395 3.60985C15.9472 4.45845 17 6.10628 17 8ZM20 18.2857C20 18.8057 19.8932 19.3007 19.7002 19.75H20.2857C21.6467 19.75 22.75 18.6467 22.75 17.2857C22.75 14.5046 20.4954 12.25 17.7143 12.25H15.4752C18.0896 13.0115 20 15.4255 20 18.2857Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserGroup03SolidRounded);
export default __webpack_public_path__ + "static/media/user-group-03-solid-rounded.07d5fd3db1eb880de097e452b762704e.svg";
export { ForwardRef as ReactComponent };